<script setup lang="ts">
  defineProps<{
    icon: string,
    fixedWidth?: boolean,
  }>()
</script>

<template>
  <span :class="[icon, 'fa-icon inline-block', { 'w-1.2em': fixedWidth }]"></span>
</template>
